import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { COLOR } from "../../styles/Colors";
import { TEXT } from "../../styles/Text";
import { IGender } from "../../types/influencerAccount";

interface Props {
  genders: Array<IGender>;
  dataExistFollowers: number;
}

const Gender = (props: Props) => {
  const { genders, dataExistFollowers } = props;
  if (genders.length === 0) {
    return null;
  }

  const genderDemographic = (
    gender: string,
    followers: number,
    isFirst = false
  ) => {
    let fullGender;
    switch (gender) {
      case "F":
        fullGender = "Female";
        break;
      case "M":
        fullGender = "Male";
        break;
      case "U":
        fullGender = "Others";
        break;
    }

    return (
      <View style={styles.row}>
        <Text style={styles.value} numberOfLines={1}>
          {fullGender}
        </Text>
        <View style={styles.container}>
          <View
            style={{
              backgroundColor: isFirst ? COLOR.GREEN : COLOR.LIGHTGREEN,
              borderRadius: 10,
              height: "100%",
              width: `${Math.round((followers / dataExistFollowers) * 100)}%`,
            }}
          />
        </View>
        <Text style={styles.percentage} numberOfLines={1}>
          {Math.round((followers / dataExistFollowers) * 100)}%
        </Text>
      </View>
    );
  };

  return (
    <View style={styles.contentContainer}>
      {genderDemographic(genders[0][0], genders[0][1], true)}
      {genderDemographic(genders[1][0], genders[1][1])}
      {genderDemographic(genders[2][0], genders[2][1])}
    </View>
  );
};

export default Gender;

const styles = StyleSheet.create({
  contentContainer: {
    width: "66%",
    alignSelf: "center",
    gap: 16,
  },
  header: {
    ...TEXT.caption2,
    color: COLOR.DARKGRAY,
    marginTop: 10,
  },
  row: {
    flexDirection: "row",
  },
  value: {
    width: "30%",
    alignItems: "center",
    marginRight: 4,
    ...TEXT.body1,
  },
  container: {
    height: 10,
    flex: 1,
    alignSelf: "center",
  },
  percentage: {
    width: "20%",
    textAlign: "right",
    ...TEXT.body2BOLD,
  },
});
